export class Sponsor {
  public sponsorId: number
  public sponsorName: string
  public attention: string
  public tradingFax: number
  public insuranceFax: number
  public active: boolean
  public sponsorProductTypes: SponsorProductTypes[]

  constructor(cons: Partial<Sponsor>) {
    this.sponsorId = cons?.sponsorId
    this.sponsorName = cons?.sponsorName
    this.attention = cons?.attention
    this.tradingFax = cons?.tradingFax
    this.insuranceFax = cons?.insuranceFax
    this.active = cons?.active
    this.sponsorProductTypes = []
  }
}

export class SponsorProductTypes {
  public sponsorProductTypeId: number
  public sponsorId: number
  public productTypeId: number
}
